import { fromJS } from 'immutable';
import { createReducer } from 'redux-create-reducer';
import * as actions from './actions';
import * as analytics from '../../utils/analytics';
import { ANALYTICS_ERROR, BRAND_ID } from '../../utils/constants';

export const initialState = fromJS({
  bank_id: 'cb',
  brand_id: 'cb',
  loading: false
});

export default createReducer(initialState, {
  [actions.FETCH_CONFIG]: (state) => state.set('loading', true),
  [actions.FETCH_CONFIG_FAILED]: (state, action) => {
    analytics.error({ errorCode: 0, errorMessage: ANALYTICS_ERROR.FETCH_CONFIG_FAILED });
    return state.set('loading', false).set('error', action.error);
  },
  [actions.FETCH_CONFIG_SUCCESS]: (state, action) => {
    let localState = state;
    localState = localState.set('loading', false).merge(action.payload);
    const brandName = localState.get(BRAND_ID);
    analytics.initialize({ brandName });
    return localState;
  }
});
